import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Depot from '@/plugins/sdk/resources/Depot'
import Carrier from '@/plugins/sdk/resources/Carrier'

export default class extends Resource {
  static name = 'carrierdepot'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      depot: new ITEM(Depot),
      carrier: new ITEM(Carrier)
    }
  }
}
